import n from "../../store/useStore.js";
import { server as _ } from "../../config/axios.js";
import { useNotify as te } from "../../hooks/useNotify.js";
import { getHighestPriceImpact as oe } from "../../utils/formatNumber.js";
import { CARDANO_TOKEN_IDENTIFIER as R } from "../components/tokens.js";
import "react";
import "../../_commonjsHelpers-10dfc225.js";
import "../../index-9d43cc8b.js";
import "../../store/createTokenSearchSlice.js";
import "../../immer-548168ec.js";
import "../../store/createWalletSlice.js";
import "../../store/createSwapSettingsSlice.js";
import "../../store/createGlobalSettingsSlice.js";
import "../../store/createUserOrdersSlice.js";
import "../../store/createSwapSlice.js";
import "../../store/createChartSlice.js";
import "../../store/createBasketSlice.js";
import "../../store/createModalWhatsNewSlice.js";
import "../../store/createSwapParamsSlice.js";
import "../../index-ca8eb9e1.js";
import "../../axios-ddd885c5.js";
import "../../config/decrypt.js";
import "react/jsx-runtime";
import "../../react-toastify.esm-a636d9b1.js";
import "../../assets/svg/IconCopy.js";
import "../../assets/svg/IconX.js";
import "../../assets/svg/IconCheckNotify.js";
import "../../assets/svg/IconAlertTriangleNotify.js";
import "../../assets/svg/IconArrowUpRightNotify.js";
import "../../lib.js";
import "../../extend-tailwind-merge-e63b2b56.js";
import "../../hooks/useScreen.js";
const Le = () => {
  const { notify: h } = te(), {
    tokenBuy: s,
    tokenSell: o,
    sellAmount: p,
    setIsTransactionLoading: b,
    estimationError: U,
    dexBlacklist: M,
    setBuyAmount: V,
    setSellAmount: W,
    setSwapDetails: L,
    swapDetails: t,
    bonusOutput: u,
    setDexBlacklist: Y,
    setIsSwapSubmitted: B,
    setBonusOutput: j,
    inputMode: v,
    onViewOrder: x
  } = n((e) => e.swapSlice), { swapType: G } = n((e) => e.tokenSearchSlice), {
    api: c,
    userAddress: S
  } = n((e) => e.walletSlice), { slippage: z, isDexSplitting: H, isAutomaticSlippage: J } = n((e) => e.swapSettingsSlice), { setUpcomingOrders: K, setPendingOrdersCount: X, pendingOrdersCount: $ } = n((e) => e.userOrdersSlice), { balance: A } = n((e) => e.walletSlice), { partnerName: q, partnerCode: D, inputs: Q } = n((e) => e.globalSettingsSlice), Z = () => {
    const e = ((t == null ? void 0 : t.total_fee) + (t == null ? void 0 : t.partner_fee)) / 1e6, d = parseFloat(p);
    return v === "BUY" ? parseFloat(t.total_input_without_slippage) : d + e > A && (o == null ? void 0 : o.token_id) === "" ? parseFloat(d - e) : parseFloat(d);
  };
  return { buyToken: async () => {
    var d, I, y, T, w, E, C, N, O, P;
    if (b(!0), p === 0 || U) {
      b(!1);
      return;
    }
    let e = {
      sign: null,
      tx: "",
      payload: null,
      ada_balance: A,
      err: null,
      step: "pre-swap",
      signatures: null
    };
    try {
      console.time("swap");
      let i = J ? oe(t, !0) + 1 : z;
      ((d = t == null ? void 0 : t.splits) == null ? void 0 : d.length) === 0 && ((y = (I = t == null ? void 0 : t.splits) == null ? void 0 : I[0]) == null ? void 0 : y.dex) === "MUESLISWAP" && (i = 0), ((o == null ? void 0 : o.token_id) === "e52964af4fffdb54504859875b1827b60ba679074996156461143dc14f5054494d" || (s == null ? void 0 : s.token_id) === "e52964af4fffdb54504859875b1827b60ba679074996156461143dc14f5054494d") && (i = Math.min(i, 50));
      let f = M;
      ((s == null ? void 0 : s.token_id) === "8a1cfae21368b8bebbbed9800fec304e95cce39a2a57dc35e2e3ebaa4d494c4b" || (o == null ? void 0 : o.token_id) === "8a1cfae21368b8bebbbed9800fec304e95cce39a2a57dc35e2e3ebaa4d494c4b") && ((o == null ? void 0 : o.token_id) === "" && p <= 500 && (f = ["WINGRIDER", "SUNDAESWAP", "SPECTRUM", "VYFI"]), (o == null ? void 0 : o.token_id) === "8a1cfae21368b8bebbbed9800fec304e95cce39a2a57dc35e2e3ebaa4d494c4b" && p <= 50 && (f = ["WINGRIDER", "SUNDAESWAP", "SPECTRUM", "VYFI"]));
      const k = {
        buyer_address: S,
        token_in: o == null ? void 0 : o.token_id,
        token_out: (s == null ? void 0 : s.token_id) || "",
        slippage: i,
        amount_in: Z(),
        tx_optimization: H,
        blacklisted_dexes: f,
        referrer: q,
        inputs: Q
      };
      e.payload = k;
      const { data: a } = await _.post("/swap", k, {
        headers: {
          "X-Partner-Id": D
        }
      });
      e.swap = a, e.step = "pre-sign";
      const F = await (c == null ? void 0 : c.signTx(a == null ? void 0 : a.cbor, !1)), { data: m } = await _.post("/swap/sign", {
        txCbor: a == null ? void 0 : a.cbor,
        signatures: F
      });
      e.sign = m, e.signatures = F, e.step = "pre-submit";
      const g = await (c == null ? void 0 : c.submitTx(m == null ? void 0 : m.cbor));
      e.tx = g, e.step = "after-submit";
      const ee = "Success" + (parseFloat(u == null ? void 0 : u.replace("+", "").replace(" ADA", "").trim()) !== 0 && ((T = t == null ? void 0 : t.splits) == null ? void 0 : T.length) > 1 ? `. Bonus: ${u}` : "");
      try {
        await _.post("/marking/submit", {
          tx_hash: g,
          order_type: "SWAP"
        });
      } catch (r) {
        console.log(r), e.marking_err = ((w = r == null ? void 0 : r.response) == null ? void 0 : w.data) || (r == null ? void 0 : r.message) || (r == null ? void 0 : r.info);
      }
      B(!0);
      const l = (E = t == null ? void 0 : t.splits) == null ? void 0 : E.map((r) => ({
        ...r,
        tx_hash: g,
        status: "SUBMITTED",
        amount_in: p,
        token_id_in: (o == null ? void 0 : o.token_id) || R,
        token_id_out: (s == null ? void 0 : s.token_id) || R,
        expected_out_amount: r == null ? void 0 : r.expected_output,
        submission_time: (/* @__PURE__ */ new Date()).toISOString(),
        user_address: S,
        upcoming: !0,
        type: G,
        is_dexhunter: !0
      }));
      h({
        type: "success",
        title: ee,
        desc: "Your order has been placed successfully",
        actionName: "View order",
        dataCallback: l,
        actionCallback: () => {
          var r;
          if (x) {
            x(l);
            return;
          }
          (r = window.open("https://app.dexhunter.io/orders", "_blank")) == null || r.focus(), console.log(l, "callback");
        }
      }), K(l), X($ + ((C = t == null ? void 0 : t.splits) == null ? void 0 : C.length)), W(0), V(0), L(null), Y([]), j("");
    } catch (i) {
      if (console.log(i), console.log(i.message), e.err = ((N = i.response) == null ? void 0 : N.data) || i.message || i.info, (O = i.message) != null && O.toLowerCase().includes("declined") || (P = i.info) != null && P.toLowerCase().includes("declined"))
        return;
      h({
        type: "error",
        title: "Error placing order",
        desc: "There was an error placing your order",
        actionCallback: () => {
          navigator.clipboard.writeText(JSON.stringify(e));
        }
      });
    } finally {
      b(!1);
    }
  } };
};
export {
  Le as useSwapAction
};
